export default __webpack_public_path__ + "static/media/sidebar-3.a431a6a0.png";